/* eslint-disable @typescript-eslint/no-explicit-any */
import type { ResponseError, RequestOptionsInit, RequestResponse } from 'umi-request';
import { extend } from 'umi-request';

// jwttoken緩存key名稱
export const tokenCacheKey = `${location.origin}_token`;

/* 异常处理 */
const errorHandler = function (error: ResponseError) {
  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    console.error(error.response.status, error.request);
  } else {
    // The request was made but no response was received or error occurs when setting up the request.
    console.error('Request error:', error.message);
  }
  throw error;
};

const request = extend({
  // 为每个请求添加前缀
  prefix: API_HOST,
  errorHandler,
  headers: {
  },
  getResponse: true,
});

// 未有Token时请求加入队列
const requestTask: any[] = [];
let tempToken = '';
function runRequestTask() {
  while (requestTask.length) {
    requestTask.shift()?.();
  }
}

export function setToken(token: string) {
  localStorage.setItem(tokenCacheKey, token);
  request.extendOptions({
    headers: {
      Authorization: token,
    },
  });
  tempToken = token;
  runRequestTask();
}

let yiwangToken = '';
export function setYiWangToken(token: string) {
  yiwangToken = token;
  localStorage.setItem('token', token);
}
export function getYiWangToken() {
  return yiwangToken;
}

/**
 * 設置請求語言header
 *
 **/
export function setAcceptLanguage(lang) {
  if (lang) {
    request.extendOptions({
      headers: {
        'Accept-Language': lang,
      },
    });
  }
}

/**
 * 处理data
 * @param res
 * @returns
 */
const handleResponseData = <T>(res: RequestResponse<T>) => {
  const { data, response } = res;
  const refreshToken = response.headers.get('authorization');
  if (refreshToken) {
    setToken(refreshToken);
  }
  return data;
};

/**
 * 有token或者在声明api时设置了canSendWithoutToken为true的可通过。
 * @param options
 * @returns
 */
function getCanUrlSend(options) {
  return tempToken || options?.canSendWithoutToken || options?.headers?.Authorization;
}

/**
 * Middleware
 * 有Token或设置了canSendWithoutToken时直接请求
 * 无则加入请求队列
 */
request.use(async (ctx, next) => {
  const { req } = ctx;
  const { options } = req;
  if (!getCanUrlSend(options)) {
    await new Promise((resolve) => {
      requestTask.push(resolve);
    });
    // 处理已经压入队列的request取不到token的问题。
    options.headers = { ...options.headers, Authorization: tempToken };
  }
  await next();
});

const get = <T = any>(
  url: string,
  params?: Record<string, number | string | boolean> | URLSearchParams,
  options?: RequestOptionsInit,
) =>
    request
      .get<T>(url, { ...options, params })
      .then(handleResponseData);

const post = <T = any>(url: string, data?: Record<string, any>, options?: RequestOptionsInit) =>
  request
    .post<T>(url, { ...options, data })
    .then(handleResponseData);

const put = <T = any>(url: string, data?: Record<string, any>, options?: RequestOptionsInit) =>
  request
    .put<T>(url, { ...options, data })
    .then(handleResponseData);

const del = <T = any>(url: string, data?: Record<string, any>, options?: RequestOptionsInit) =>
  request
    .delete<T>(url, { ...options, data })
    .then(handleResponseData);

/**
 * // How to upload file?
 * const formData = new FormData();
 * formData.append('file', file);
 * fetch('/api/v1/some/api', { method: 'POST', body: formData });
 */

// 导出你所需要使用的方法
export { request, get, post, put, del };

export interface FetchResponse<T> {
  message: string;
  code: number;
  data: T;
  success: boolean;
}
